import gitVersion from './gitVersion.json'
import { IS_DEVNET, IS_TESTNET } from '@shared/utils/constant'
import devnetTokens from '@/app/json/tokens/devnet.json'
import testnetTokens from '@/app/json/tokens/testnet.json'
import mainnetTokens from '@/app/json/tokens/mainnet.json'
import devnetValidators from '@/app/json/validators/devnet.json'
import testnetValidators from '@/app/json/validators/testnet.json'
import mainnetValidators from '@/app/json/validators/mainnet.json'
import devnetSpotMarkets from '@/app/json/markets/spot/devnet.json'
import testnetSpotMarkets from '@/app/json/markets/spot/testnet.json'
import mainnetSpotMarkets from '@/app/json/markets/spot/mainnet.json'
import restrictedCountriesJson from '@/app/json/restrictedCountries.json'
import blacklistedAddressesJson from '@/app/json/blacklistedAddresses.json'
import devnetDerivativeMarkets from '@/app/json/markets/derivative/devnet.json'
import testnetDerivativeMarkets from '@/app/json/markets/derivative/testnet.json'
import mainnetDerivativeMarkets from '@/app/json/markets/derivative/mainnet.json'

export const getTokens = () => {
  if (IS_DEVNET) {
    return devnetTokens
  }

  if (IS_TESTNET) {
    return testnetTokens
  }

  return mainnetTokens
}

export const getValidators = () => {
  if (IS_DEVNET) {
    return devnetValidators
  }

  if (IS_TESTNET) {
    return testnetValidators
  }

  return mainnetValidators
}

export const getSpotMarkets = () => {
  if (IS_DEVNET) {
    return devnetSpotMarkets
  }

  if (IS_TESTNET) {
    return testnetSpotMarkets
  }

  return mainnetSpotMarkets
}

export const getDerivativeMarkets = () => {
  if (IS_DEVNET) {
    return devnetDerivativeMarkets
  }

  if (IS_TESTNET) {
    return testnetDerivativeMarkets
  }

  return mainnetDerivativeMarkets
}

export const gitBuild = () => {
  return (
    gitVersion || {
      branch: 'master',
      tag: 'v0.0.0',
      gitTagLink: '',
      logs: []
    }
  )
}

export const restrictedCountries = restrictedCountriesJson
export const blacklistedAddresses = blacklistedAddressesJson

export const tokens = getTokens()
export const validators = getValidators()
export const spotMarkets = getSpotMarkets()
export const derivativeMarkets = getDerivativeMarkets()
